"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var $ = require("jquery");
var _ = require("lodash");
var toastr = require("toastr");
var baseViewModel_1 = require("../viewModels/base/baseViewModel");
var modalDialog_1 = require("../components/modalDialog");
var ajaxUtils_1 = require("../utils/ajaxUtils");
var PostUtils = (function (_super) {
    __extends(PostUtils, _super);
    function PostUtils() {
        _super.call(this);
    }
    PostUtils.prototype.vote = function (btn, postId, vote) {
        var $icon = $(btn), $btn = $icon.parent();
        if ($btn.attr("disabled"))
            return;
        $btn.attr("disabled", "disabled");
        var toggleClass = "toggle", $rating = $btn.siblings(".rating-count"), voteId = $rating.attr("data-vote-id");
        if (!$icon.hasClass(toggleClass)) {
            $btn.addClass("animate");
            setTimeout(function () {
                $btn.removeClass("animate");
            }, 500);
        }
        ajaxUtils_1.AjaxUtils.post("post/vote", {
            voteId: voteId,
            targetId: postId,
            isLiked: $icon.hasClass(toggleClass) ? null : vote === 1
        }).done(function (result) {
            if (result.isSuccessful) {
                $rating.html(result.data.rating);
                $rating.attr("data-vote-id", result.data.voteId);
                if ($icon.hasClass(toggleClass)) {
                    $icon.removeClass(toggleClass);
                    $icon.addClass("hover-state-canceled");
                    $icon.on("mouseleave", function () {
                        $icon.removeClass("hover-state-canceled");
                        $icon.off("mouseleave");
                    });
                }
                else {
                    $btn.siblings().find(".like, .dislike").removeClass(toggleClass);
                    $icon.removeClass("hover-state-canceled");
                    $icon.addClass(toggleClass);
                }
            }
            else if (result.isWarning) {
                toastr.warning(result.messages[0]);
            }
            else {
                alert(result.messages[0]);
            }
        }).always(function () {
            $btn.removeAttr("disabled");
        });
    };
    PostUtils.prototype.toggleFavorite = function (btn, postId) {
        var _this = this;
        var $btn = $(btn), $icon = $btn.find("i");
        if ($btn.attr("disabled"))
            return;
        $btn.attr("disabled", "disabled");
        var toggleClass = "toggle", isActive = $icon.hasClass(toggleClass);
        if (!isActive) {
            $btn.addClass("animate");
            setTimeout(function () {
                $btn.removeClass("animate");
            }, 500);
        }
        var ajaxSetFavor = function () {
            ajaxUtils_1.AjaxUtils.post("post/toggleFavorite", {
                postId: postId,
                toggle: !isActive
            }).done(function (result) {
                if (result.isSuccessful) {
                    if (isActive) {
                        $icon.removeClass(toggleClass);
                        $btn.attr("data-hint", "Добавить пост в сохраненные");
                    }
                    else {
                        $icon.addClass(toggleClass);
                        $btn.attr("data-hint", "Удалить пост из сохраненных");
                    }
                }
                else if (result.isWarning) {
                    toastr.warning(result.messages[0]);
                }
                else {
                    alert(result.messages[0]);
                }
            }).always(function () {
                $btn.removeAttr("disabled");
            });
        };
        if (isActive) {
            this.showModal({
                title: "Вы уверены?",
                message: "\u0412\u044B \u0442\u043E\u0447\u043D\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u043E\u0441\u0442 \u0438\u0437 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043D\u044B\u0445?",
                maxWidth: "400px",
                type: modalDialog_1.ModalType.ConfirmDelete,
                deleteBtnText: "Удалить",
                onSubmit: function () {
                    ajaxSetFavor();
                    _this.modal.hide();
                }
            });
            $btn.removeAttr("disabled");
        }
        else {
            ajaxSetFavor();
        }
    };
    PostUtils.prototype.toggleUserPinned = function (btn, postId, toogle) {
        var _this = this;
        var $btn = $(btn);
        var postPinnedClass = 'post-pinned', toogleClass = 'toogle', isActive = $btn.hasClass(toogleClass);
        if ($btn.attr("disabled"))
            return;
        $btn.attr("disabled", "disabled");
        ajaxUtils_1.AjaxUtils.post("post/toggleUserPin", {
            objectId: postId,
            enabled: !isActive
        }).done(function (result) {
            if (result.isSuccessful) {
                if (!isActive) {
                    $("." + postPinnedClass + "." + toogleClass).removeClass(toogleClass);
                }
                $btn.addClass(toogleClass);
                toastr.success(result.messages[0]);
                setTimeout(function () {
                    _this.reloadPage();
                }, 1000);
            }
            else if (result.isWarning) {
                toastr.warning(result.messages[0]);
            }
            else {
                alert(result.messages[0]);
            }
        }).always(function () {
            $btn.removeAttr("disabled");
        });
    };
    PostUtils.startViewStatsCollector = function () {
        try {
            var $posts = $(".post");
            var observerElements = $posts.toArray();
            // Создаем новый observer (наблюдатель)
            var observer_1 = new window["IntersectionObserver"](function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        setTimeout(function () {
                            var parent = entry.target.parentNode;
                            if (observerElements.indexOf(parent) >= 0 &&
                                entry.target.getBoundingClientRect().bottom > 0 &&
                                entry.target.getBoundingClientRect().top < document.documentElement.clientHeight) {
                                observerElements = observerElements.filter(function (elem) { return elem !== parent; });
                                var id = $(parent).attr("id").split("_")[1];
                                ajaxUtils_1.AjaxUtils.post(app.statsApiUrl + "post/hit/" + id, {});
                            }
                        }, 10000); // 10 секунд
                    }
                });
            });
            $posts.find(".rich-content").each(function (index, el) {
                observer_1.observe(el);
            });
        }
        catch (e) {
            console.error(e);
        }
    };
    return PostUtils;
}(baseViewModel_1.BaseViewModel));
_.extend(window["AppUtils"], {
    Post: new PostUtils()
});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PostUtils;
//# sourceMappingURL=postUtils.js.map